// Chosen directive for all progressbars
export function CoreProgressBarDirective () {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.progressbar();
      scope.$watch('percentage', function (progress) {
        if (progress !== undefined) element.progressbar({value: parseFloat(progress)})
      }, true);
    }
  }
}